// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store";
import VueResource from "vue-resource";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faGlobe, faHome, faPhoneSquare, faMapMarkerAlt, faEnvelope, faCircle} from "@fortawesome/free-solid-svg-icons";
import { faCircle as farCircle} from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

Vue.config.productionTip = false

Vue.use(VueResource);

library.add(faGlobe, faHome, faPhoneSquare, faMapMarkerAlt, faEnvelope, faCircle, farCircle );
Vue.component('font-icon', FontAwesomeIcon)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js